import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import {
  RichTextEditorComponent,
  ToolbarSettingsModel,
  QuickToolbarSettingsModel,
} from "@syncfusion/ej2-angular-richtexteditor";
import { fontFamily, size } from "./data-config";

@Component({
  selector: "rs-richtext-editor",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class RichtexteditorComponent {
  @ViewChild("editor", { static: false })
  public rteObj: RichTextEditorComponent;
  @Input() value = "";
  @Input() placeholder = "";
  @Input() maxlength = "";
  @Input() editorId = "editorId";
  @Input() height = 150;
  @Input() autoSaveOnIdle = true;
  @Input() disabled = false;
  @Input() saveInterval = 500;
  @Input() enableAutoUrl = true;
  @Input() insertImageSettings = {
    saveFormat: "Blob",
    allowedTypes: [".svg", ".png"],
    display: "none",
  };

  @Output() toolbarClick = new EventEmitter();
  @Output() change = new EventEmitter();
  @Output() created = new EventEmitter();
  @Output() actionBegin = new EventEmitter();
  @Output() input = new EventEmitter();
  @Output() focus = new EventEmitter();
  @Output() blur = new EventEmitter();
  @Output() actionComplete = new EventEmitter();

  family = fontFamily;
  fontSize = size;
  tools: ToolbarSettingsModel = {
    enableFloating: false,
    items: [
      "Bold",
      "Italic",
      "Underline",
      "StrikeThrough",
      "FontName",
      "FontSize",
      "FontColor",
      "BackgroundColor",
      "LowerCase",
      "UpperCase",
      "|",
      "CreateTable",
      "LineHeight",
      "Formats",
      "Alignments",
      "bulletFormatList",
      "NumberFormatList",
      "Outdent",
      "Indent",
      "|",
      "CreateLink",
      "|",
      "FormatPainter",
      "ClearFormat",
      "|",
      "Undo",
      "Redo",
    ],
  };
  /** 表格快捷工具栏：含 TableCell（合并/拆分单元格） */
  quickToolbarSettings: QuickToolbarSettingsModel = {
    table: [
      "Tableheader",
      "TableRemove",
      "|",
      "TableRows",
      "TableColumns",
      "TableCell",
      "|",
      "Styles",
      "BackgroundColor",
      "Alignments",
      "TableCellVerticalAlign",
    ],
  };
  public bulletFormatList = {
    types: [
      { text: "None", value: "none" },
      { text: "●", value: "disc" },
      { text: "○", value: "circle" },
      { text: "■", value: "square" },
      { text: "-", value: "dash" },
    ],
  };
  public numberFormatList = {
    types: [
      { text: "None", value: "none" },
      { text: "1, 2, 3, …", value: "decimal" },
      {
        text: "α, β, γ, …",
        value: "lowerGreek",
      },
      {
        text: "i, ii, iii, …",
        value: "lowerRoman",
      },
      {
        text: "A, B, C, …",
        value: "upperAlpha",
      },
      {
        text: "a, b, c, …",
        value: "lowerAlpha",
      },
      {
        text: "I, II, III, …",
        value: "upperRoman",
      },
      {
        text: "(1), (2), (3), …",
        value: "parentheses",
      },
    ],
  };

  onContentChange(args) {
    this.change.emit(args);
  }

  public onCreate(): void {
    this.created.emit();
  }

  _toolbarClick(args) {
    this.toolbarClick.emit(args);
  }

  _actionBegin(args) {
    this.actionBegin.emit(args);
  }

  _input(args) {
    this.input.emit(args);
  }

  _actionComplete(args) {
    if (args.requestType == "UL") {
      if (args.elements[0].parentElement.style.listStyleType == "dash") {
        args.elements[0].parentElement.style.listStyleImage =
          "url('../../../assets/img/bullet-dash.svg')";
        args.elements[0].parentElement.style.listStyleType = "none";
      }
    } else if (args.requestType == "OL") {
      args.elements[0].parentElement.classList.remove(
        "custom-list",
        "parentheses"
      );
      if (args.elements[0].parentElement.style.listStyleType == "parentheses") {
        args.elements[0].parentElement.classList = "custom-list";
        args.elements[0].parentElement.classList.add("parentheses");
      }
    }
    this.actionComplete.emit(args);
  }

  _focus(args) {
    this.focus.emit(args);
  }

  _blur(args) {
    this.blur.emit(args);
  }
}
